import { DiagnosisSummary } from "./DiagnosisSummary";
import { FinancialSummary } from "./FinancialSummary";
import { OverviewFilter } from "./OverviewFilter";
import { RecoveryFunnel } from "./RecoveryFunnel";

export function Overview() {
  return (
    <div className="flex flex-col gap-5">
      <OverviewFilter />
      <DiagnosisSummary />
      <div className="grid items-start gap-5 xl:grid-cols-2">
        <RecoveryFunnel />
        <FinancialSummary />
      </div>
    </div>
  );
}
